import React from "react"
import propTypes from "prop-types"
import { useQuery } from "@tanstack/react-query"
import { RenderTicketContent } from "components/sales"
import { getBusinessInfo } from "services/business-info"

const TicketDetail = ({ ticket }) => {
  const businessInfo = useQuery(["business-info"], () => getBusinessInfo())

  if (!ticket) {
    return <div className="text-center">No se encontraron datos del ticket</div>
  }

  const products = (ticket.products || ticket.items || []).map((item, index) => ({
    ...item,
    id: item.id || index,
    quantity: item.quantity || 0,
    description: item.description || item.product?.description || item.product?.product?.name || "Producto",
    price: Number(item.price ?? item.unit_price ?? 0),
    total: Number(item.total ?? item.amount ?? 0),
    suggested: item.suggested ?? item.suggested_price ?? item.suggestedPrice ?? item.price_suggested,
  }))

  const ticketData = {
    ...ticket,
    products,
    total: ticket.total ?? Number(ticket.subtotal || 0) - Number(ticket.discount || 0),
    total_string: ticket.total_string || ticket.total_text || "",
    total_text: ticket.total_text || ticket.total_string || "",
  }

  return <RenderTicketContent data={ticketData} businessInfo={businessInfo} />
}

TicketDetail.propTypes = {
  ticket: propTypes.object,
}

export default TicketDetail
